const ZipcodeColor = ({ color, wider }: { color: string; wider?: boolean }) => {
  return (
    <div className="h-[3rem] rounded-[0.5rem] border-[1px_solid_var(--border)]" style={{ width: wider ? "7.5rem" : "3rem", backgroundColor: color }}></div>
  );
};

export default ZipcodeColor;
